import React,{ Component } from "react";
import { connect } from "react-redux";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import OidcConfigForm from "../OidcConfigForm/OidcConfigForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import {updateOidcConfig} from "../../../actions/actionOidc";
import MappingTable from "../../../components/MappingTable/";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Oidc",path:"/oidc",isActive: false},
    {name: "UpdateOidc",path:"/updateoidc",isActive: true},
];

class UpdateOidcConfig extends Component{
    render(){
        return (
            <div>
                <BreadCrumbCompo routes={routes}/>
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update OpenID Config </strong>
                                </CardHeader>
                                <OidcConfigForm
                                    updateOidcConfig={this.props.updateOidcConfig}
                                    oidcConfigId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                            <Card className = "user-form-container">
                                <MappingTable sso_id={this.props.match.params.id} sso_type="OIDC" />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

UpdateOidcConfig.propTypes = {
    updateOidcConfig: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
        oidc_configs: state.oidc.oidc_configs || [],
    }),
    dispatch => ({
        updateOidcConfig: (data) => dispatch(updateOidcConfig(data))
    }))(UpdateOidcConfig);